import React, { Suspense, useEffect, useState } from 'react';
import {Switch, Route} from "react-router-dom";
import { BrowserRouter } from 'react-router-dom';
import client from './clients';
import ManageBranchUser from './auth/ManageBranchUser';
import SkeletonLoader from './components/skeleton-loader/index';
import SplashScreen from './components/splash-screen';
import BiometricDevice from './features/biometric-device';
import { getBranch, getBranchNoAuth } from './features/gyms/helper/api';
import SalesKiosk from './features/salesKiosk';
// import SignUp from './core/Signup';
const Signin = React.lazy(() => import('./core/Signin'))
const ResetPassword =  React.lazy(() => import('./core/ResetPassword'));
const AdminUserRoutes =  React.lazy(() => import('./auth/AdminUserRoutes'));
const AdminRoutes =  React.lazy(() => import('./auth/AdminRoutes'));
const MemberRoute =  React.lazy(() => import('./auth/MemberRoute'));
const Company =  React.lazy(() => import('./features/company/index'));
// const GymMob =  React.lazy(() => import('./features/company/mobile/ManageGym'));
// const GymDashboard =  React.lazy(() => import('./features/company/Dashboard'));
const ManageContent =  React.lazy(() => import('./features/content/ManageContent'));
const ManageContentMob =  React.lazy(() => import('./features/content/mobile/ManageContent'));
const ContentView =  React.lazy(() => import('./features/content/modal/ContentView'));
// import ExerciseType from './components/content/ManageExerciseType';
// import ExerciseLevel from './components/content/ManageExerciseLevel';
// import TargetMuscle from './components/content/ManageTargetMuscle';
// import TestDashboard from './components/TestDashboard';components/content/ManageContent
// const BranchAdmin = React.lazy(() => import('./components/admin/ManageBranchInstructor'));

// import MemberTestDashboard from './member/memberTestDashboard';
const PlannerView =  React.lazy(() => import('./features/planner/components/planner-preview'));
// const ManagePlanner = React.lazy(() => import('./features/planner/components/planner-preview'));
// import WorkoutReportDashboard from './member/workoutReportDashboard';
// import PlannerHistoryDashboard from './member/plannerHistoryDashboard';
// const GymProfile =  React.lazy(() => import('./features/company/GymProfile'));
// const BranchProfile =  React.lazy(() => import('./features/gyms/BranchProfile'));
const Appointment =  React.lazy(() => import('./features/appointment/index'));
// const AppointmentMob =  React.lazy(() => import('./appointment/MemberManageAppointmentMob'));
// const ManageAppointment =  React.lazy(() => import('./appointment/ManageAppointment'));
// const MemberAppointmentView =  React.lazy(() => import('./members/memberAppointment'));

//new components
const Parameters =  React.lazy(() => import('./features/parameters/Parameters'));
const ParametersMob =  React.lazy(() => import('./features/parameters/ParameterMob'));
const MemberProfile =  React.lazy(() => import('./features/member/components/member-profile'));
// const memberReport =  React.lazy(() => import('./members/memberReport'));
const MemberDashboard =  React.lazy(() => import('./features/member/member-dashboard'));
// const MemberDashboardDesktop =  React.lazy(() => import('./members/desktop/memberDashboard'));
// const UserDashboardMob =  React.lazy(() => import('./features/employees/Mobile/UserDashboard'));
// const UserDashboardDesktop =  React.lazy(() => import('./features/employees/Desktop/UserDashboard'));
const Scanner =  React.lazy(() => import('./core/Scanner'));
// const MemberWorkoutSchedule =  React.lazy(() => import('./members/mobile/memberWorkoutSchedule'));
// const ManageExercise =  React.lazy(() => import('./features/planner/manageExercise'));
// const AddExercise =  React.lazy(() => import('./features/planner/addExercise'));
const MemberRegistration =  React.lazy(() => import("./features/member/components/member-registration"));
const ManageUsers =  React.lazy(() => import("./features/employees/index"));
// const ManageUsersMob =  React.lazy(() => import('./features/employees/ManageUsersMob'));
const UserRegistration =  React.lazy(() => import('./core/UserSignup'));
const SetPassword =  React.lazy(() => import('./core/SetPassword'));
// const PhysiologicalParameter =   React.lazy(() => import('./members/desktop/physiologicalParameter'));
// const FitnessMeasurement =  React.lazy(() => import('./members/desktop/fitnessMeasurement'));
// const FitnessTest =  React.lazy(() => import('./members/desktop/fitnessTest'));
// const WorkoutHistory =  React.lazy(() => import('./members/desktop/workoutHistory'));
// const MemberHistory =  React.lazy(() => import('./members/mobile/memberHistory'));
const SmartScreensDashboardDesktop =  React.lazy(() => import('./features/smart-screen/Desktop/ManageScreens'));
const SmartScreensDashboardMobile =  React.lazy(() => import('./features/smart-screen/Mobile/ManageScreens'));
// import MemberNotificationDesktop from './member/desktop/memberNotification';
// import MemberNotificationMobile from './member/mobile/memberNotification';
// import io from "socket.io-client";
// const UserNotificationMob =  React.lazy(() => import('./components/notification/mobileNotification'));
// const MemberReports =  React.lazy(() => import('./member/desktop/memberReports'));
// const MobMemberReports =  React.lazy(() => import('./member/mobile/memberReports'));
// const SocketEndpoint = "http://localhost:5000";

const PrivacyPolicy =  React.lazy(() => import('./privacy-policy/privacyPolicy'));
const TermsAndConditions =  React.lazy(() => import('./terms-and-condititons/termsAndCondition'));

// Branch
const Gym =  React.lazy(() => import('./features/gyms/index'));
// const BranchMob =  React.lazy(() => import('./features/branch/mobile/ManageBranch'));
// const BranchInfo = React.lazy(() => import('./features/gyms/components/BranchInfo'));

// Ads
const ManageAds = React.lazy(() => import('./features/ads/desktop/manageAds'));
const ManageBrand = React.lazy(() => import('./features/ads/desktop/manageBrands'));
const KioskAds = React.lazy(() => import('./features/gyms/Desktop/KioskContent'));
// const KioskAds = React.lazy(() => import('./features/ads/index'));
const Campaign = React.lazy(() => import('./features/campaign/index'));

// GSR 
const ReportGSR = React.lazy(() => import('./features/gsr-report/Desktop/index'));

// Personal Training
// const PersonalTraining = React.lazy(() => import('./personal-training/index'));

//redirect page
const Redirectpage = React.lazy(()=> import('./core/Redirectpage'));
const SetupProfile = React.lazy(() => import('./core/SetupProfile'));

//Nutrition
const NutritionDashboard = React.lazy(()=> import('./features/nutrition'));

// // Enquiry
// const ManageEnquiryDesktop =  React.lazy(() => import('./features/enquiry/desktop/manageEnquiry'));
// const ManageEnquiryMobile =  React.lazy(() => import('./features/enquiry/mobile/manageEnquiry'));
const EnquiryForm =  React.lazy(() => import('./features/enquiry/modals/enquiry-form'));
const Enquiry = React.lazy(() => import('./features/enquiry/index'));

// Follow Ups
const FollowUp = React.lazy(() => import('./features/follow-up/index'));

// Expense
const Expense = React.lazy(() => import('./features/expense'));

// Tutorial
const Tutorial = React.lazy(() => import('./features/tutorial'));

// Group Class
const GroupClass = React.lazy(() => import('./features/group-class'));


// Member
const Member =  React.lazy(() => import('./features/member/index'));
const MemberReports = React.lazy(() => import('./features/member/components/workoutHistory'));
// const MemberMob =  React.lazy(() => import('./member/mobile/manageMember'));
// const MemberInfo = React.lazy(() => import('./features/member/index'));

// Membership
const MembershipPlans = React.lazy(() => import('./features/membership-plans/index'));
const Memberships = React.lazy(() => import('./features/memberships/index'));

//Payments
const Payments = React.lazy(() => import('./features/payments/index'));

// Planners
// const PlannerDashboard =  React.lazy(() => import('./components/planner/PlannerDashboard'));
const PlannerDashboard =  React.lazy(() => import('./features/planner/index'));

const MemberPublicPlanner = React.lazy(() => import('./features/planner/components/member-public-planner'));

// Reports
const GOSReports = React.lazy(() => import('./features/gos-reports/index'));

const HomeDashboard = React.lazy(() => import('./features/dashboard/index'));

// Config
const Configurations = React.lazy(() => import('./features/configuration/index'));

// Migration
const MigrationGOS = React.lazy(() => import('./features/gos-migration')); 

// Website
// const Website = React.lazy(() => import('./home/index'));

// WPK
const WPK = React.lazy(() => import('./features/wpk'))

// User Look up
const UserLookup = React.lazy(() => import('./features/user-lookup'));


const Routes = () => {

    const [showSplash, setShowSplash] = useState(false);
    const [isBranchActive, setBranchActive] = useState(true);

    useEffect(() => {
        
        const hasVisited = localStorage.getItem("hasVisited");

        if (!hasVisited) {
        setShowSplash(true);
        
        setTimeout(() => {
            setShowSplash(false);
            localStorage.setItem("hasVisited", "true");
        }, 2000);
        }

    }, []);


    return (
        <>
        {showSplash ? <SplashScreen /> :
            <Suspense fallback={<SkeletonLoader/>}>
                <BrowserRouter>
                    <Switch>
                        {/* <Route path="/" exact component={Website} /> */}
                        <Route path="/tutorial" exact component={Tutorial} />
                        <Route path="/scanner" exact component={Scanner}/>
                        <Route path={["/signin", "/"]} exact component={client.signin}/>
                        <Route path="/signin/:branchSlug" exact component={React.lazy(()=>import('./core/BranchSignin'))} />
                        {/* <Route path="/signup" exact component={SignUp}/> */}
                        <Route path="/resetpassword/:token" exact component={ResetPassword} />
                        <Route path="/setpassword/:token" exact component={SetPassword}/>
                        <Route path="/user/registration" exact component={UserRegistration} />
                        {/* <AdminUserRoutes path="/user/Dashboard" exact component={window.innerWidth < 549 ? UserDashboardMob : UserDashboardDesktop}/>  */}
                        <AdminUserRoutes path="/companies" exact component={Company}/>
                        {/* <AdminUserRoutes path="/gym/profile/:gymId" exact component={GymProfile} /> */}
                        {/* <AdminUserRoutes path="/branch/profile/:branchId" exact component={BranchProfile}/> */}
                        <ManageBranchUser path="/gyms" exact component={Gym}/>
                        {/* <ManageBranchUser path="/branch/:branchId" exact component={Gym}/> */}
                        <AdminUserRoutes path="/ads" exact component={KioskAds}/>
                        <AdminUserRoutes path="/contents/:gymId?/:branchId?/:memberId?" exact component={ManageContent}/>
                        <AdminUserRoutes path="/content/:contentId" exact component={ContentView}/>
                        {/* <AdminUserRoutes path="/:itemId/exercise-type" exact component={ExerciseType}/>
                        <AdminUserRoutes path="/:itemId/exercise-level" exact component={ExerciseLevel}/>
                        <AdminUserRoutes path="/:itemId/target-muscle" exact component={TargetMuscle}/>
                        <AdminUserRoutes path="/:itemId/test-list" exact  component={TestDashboard}/> */}
                        <AdminUserRoutes path="/members" exact component={Member}/>
                        <AdminUserRoutes path="/member/:memberId" exact component={Member}/>
                        {/* <AdminUserRoutes path="/member/tests/:gymId/:branchId/:memberId" exact component={MemberTestDashboard}/> */}
                        <AdminUserRoutes path="/nutrition-planner/:plannerId" exact component={PlannerView}/>
                        {/* <AdminUserRoutes path="/workout/reports/:branchId/:memberId" exact component={WorkoutReportDashboard}/> */}
                        {/* <AdminUserRoutes path="/branch/admin/users" exact component={BranchAdmin}/> */}
                        {/* <AdminUserRoutes path="/gym/dashboard" exact component={GymDashboard}/> */}
                        {/* <AdminUserRoutes path="/planner/historys/:branchId/:memberId" exact component={PlannerHistoryDashboard}/>             */}
                        {/* <AdminUserRoutes path="/manage/appointment/:gymId?/:branchId?/:memberId?" exact component={window.innerWidth < 549 ? AppointmentMob : Appointment}/> */}
                        {/* <AdminUserRoutes path="/my-appointment/:memberId" exact component={MemberAppointmentView}/> */}
                        <AdminUserRoutes path="/appointment" exact component={Appointment}/>
                        <MemberRoute path="/my-schedules" exact component={Appointment} />
                        {/* new routes */}
                        {/* <AdminUserRoutes path="/member/history" exact component={MemberHistory} /> */}
                        <AdminUserRoutes path="/profile/:memberId" exact component={MemberProfile} />
                        {/* <AdminUserRoutes path="/member-report" exact component={memberReport} /> */}
                        <AdminUserRoutes path="/parameters/:userId" exact component={Parameters} />
                        <AdminUserRoutes path="/parameters" exact component={window.innerWidth < 549 ? ParametersMob : Parameters} />
                        <AdminUserRoutes path="/employees" exact component={ManageUsers} />
                        {/* <AdminUserRoutes path="/members/physiological_parameter_and_body_composition/:memberID" exact component={PhysiologicalParameter}/> */}
                        {/* <AdminUserRoutes path="/members/fitness_measurement/:memberID" exact component={window.innerWidth > 549 && FitnessMeasurement} /> */}
                        {/* <AdminUserRoutes path="/members/fitness_test/:memberID" exact component={window.innerWidth > 549 && FitnessTest} /> */}
                        {/* <AdminUserRoutes path="/members/workout_history/:memberID" exact component={window.innerWidth > 549 && WorkoutHistory} /> */}
                        {/* <AdminUserRoutes path="/members/history/:memberID" exact component={MemberHistory} /> */}
                        <MemberRoute path="/dashboard" exact component={MemberDashboard} /> 
                        <MemberRoute path="/workout-chart" exact component={MemberDashboard} />
                        <MemberRoute path="/reports" exact component={Member} />
                        <MemberRoute path="/my-appointment" exact component={MemberDashboard} />
                        <MemberRoute path="/notification" exact component={MemberDashboard} />
                        <MemberRoute path="/workout-history" exact component={MemberDashboard} />
                        <MemberRoute path="/profile" exact component={MemberDashboard} />
                        {/* <MemberRoute path="/schedule-workout" exact component={MemberWorkoutSchedule} /> */}
                        {/* <MemberRoute path="/planner-exercise" exact component={ManageExercise} /> */}
                        {/* <MemberRoute path="/add-exercise" exact component={AddExercise} /> */}
                        <Route path={["/member/registration","/member/account-setup/:memberId/:token"]} exact component={MemberRegistration} />
                        <AdminUserRoutes path="/screens" exact component={window.innerWidth > 549 ? SmartScreensDashboardDesktop : SmartScreensDashboardMobile}/>
                        {/* <Route path="/notifications" exact component={window.innerWidth > 549 ? null : UserNotificationMob}/> */}
                        <Route path="/privacy-policy" exact component={PrivacyPolicy}/>
                        <Route path="/terms-condition" exact component={TermsAndConditions}/>
                        <Route path="/enquiry/:branchId" exact component={EnquiryForm}/>
                        <AdminUserRoutes path="/enquiries" exact component={Enquiry}/>
                        {/* <Route path="/enquiries" exact component={window.innerWidth > 549 ? ManageEnquiryDesktop : ManageEnquiryMobile} /> */}
                        <Route path="/gsr-report" exact component={ReportGSR}/>
                        {/* ADS */}
                        <AdminUserRoutes path="/ads/live" exact component={ManageAds} />
                        <AdminUserRoutes path="/brands" exact component={ManageBrand} />
                        <AdminUserRoutes path="/campaign" exact component={Campaign} /> 
                        {/* Personal Training */}
                        {/* <AdminRoutes path="/personal-training" exact component={PersonalTraining} /> */}
                        
                        {/* page redirect code */}
                        <Route path="/admin/gym" exact component={Redirectpage}/>
                        <Route path="/admin/branch" exact component={Redirectpage}/>
                        <Route path="/setup" exact component={SetupProfile}/>

                        {/* Nutrition */}
                        <MemberRoute path="/nutrition" exact component={NutritionDashboard} />

                        {/* Follow Ups */}
                        <AdminUserRoutes path="/follow-up" exact component={FollowUp} />

                        {/* Expense */}
                        <AdminUserRoutes path="/expense" exact component={Expense} />

                        {/* Group Class */}
                        {/* <AdminUserRoutes path="/group-class" exact component={GroupClass} /> */}
                        
                        {/* Membership */}
                        <AdminUserRoutes path="/membership-plans" exact component={MembershipPlans} />
                        <AdminUserRoutes path="/memberships" exact component={Memberships} />

                        {/* Payments */}
                        <AdminUserRoutes path="/payments" exact component={Payments} />

                        {/* Planners */}
                        <AdminUserRoutes path="/planners" exact component={PlannerDashboard}/>
                        <AdminUserRoutes path="/planner/:plannerId" exact component={PlannerView}/>

                        {/* Member - Public Planner */}
                        <Route path="/member/planner-info/:memberId/:scheduleTemplateId" exact component={MemberPublicPlanner}/>

                        {/* Reports */}
                        <AdminUserRoutes path="/gos-reports" exact component={GOSReports}/>

                        {/* Dashboard */}
                        <AdminUserRoutes path="/home" exact component={client.home} />

                        {/* Config */}
                        <AdminUserRoutes path="/configurations" exact component={Configurations}/>

                        {/* GOS Migration */}
                        <AdminUserRoutes path="/gos/migration" exact component={MigrationGOS} />

                        <AdminUserRoutes path="/biometric" exact component={BiometricDevice}/>

                        {/* WPK - Download */}
                        <Route path="/wpk" exact component={WPK}/> 

                        {/* User LookUp */}
                        <AdminUserRoutes path="/user/lookup" exact component={UserLookup} />

                        {/* Sales Kiosk */}
                        <AdminUserRoutes path="/salesKiosk" exact component={SalesKiosk} />
                    </Switch>
                </BrowserRouter>
            </Suspense>
        }
        </>
    )
};

export default Routes;